<template>
  <div class="crumb-container">
    您当前所在位置：{{menuPath | formatPath}}
  </div>
</template>
<script>
  import global from "@/mixins/global";
  export default {
    mixins: [global],
    filters: {
      formatPath(v) {
        if (Array.isArray(v) && v.length > 0) {
          return v.join(' / ')
        } else {
          return ''
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  .crumb-container {
    width: 100%;
    padding: 10px;
    background: #ffffff;
    font-size: 14px;
    margin-bottom: 10px;
    color: #000000;
  }
</style>
